import { RbacRoleType } from '../..';

export enum RbacAdminPermObjectKey {
  // 组织管理
  OrganizationMemberManage = 'orgMemberManage', // 成员管理
  OrganizationRoleManage = 'orgRoleManage', // 角色管理

  // 用户管理
  UserManage = 'userManage', // 用户管理
  AdminAccount = 'adminAccount', // 临时用户（这里应该要拆下部分是研发管理，后续处理[/rbac-perm-sync]）

  // 工作室管理
  StudioManage = 'studioManage', // 工作室管理-游戏列表
  GameManageView = 'gameManage', // 游戏管理查看
  GameManageEdit = 'gameManageEdit', // 游戏管理编辑

  // 计费管理
  ServiceFeeManage = 'serviceFeeManage', // 价格计算器
  CompanyCertification = 'companyCertification', // 企业认证审核
  FeeCenter = 'feeCenter', // 费用中心 - 余额提现

  // 平台运营
  ServiceManage = 'serviceManage', // 上线服务
  DownloadManage = 'downloadManage', // 下载管理
  DownloadRecord = 'downloadRecord', // 下载记录
  ServiceApply = 'serviceApply', // 服务申请
  ApplySupportAccount = 'applySupportAccount',
  UpgradeNotification = 'upgradeNotification', // 升级通知
  NewsManage = 'newManage', // 下载物消息
  // DictionaryManage = 'dictionaryManage', // 字典管理（需要分配到具体的页面权限，暂未实现）
  // AppConfig = 'appConfig', // app配置
  // PermissionManage = 'permissionManage', // 权限列表
  // SupportPermissionManage = 'supportPermissionManage', // 权限列表
  // 业务建联
  ContactUS = 'dictionaryManage', // 建联记录
  MessageManage = 'messageManage', // 消息推送
  BusinessNotice = 'businessNotice', // 业务通知
}

export interface IAdminRbacRole {
  readonly roleId: number;
  readonly roleName: string;
  readonly type: RbacRoleType;
  readonly permissions: readonly RbacAdminPermObjectKey[];
  readonly userList: readonly string[];
  readonly desc: string;
  readonly projectId: string;
}

export interface IApiAdminRbacRole extends IAdminRbacRole {
  readonly createdAt: string;
  readonly updatedAt: string;
}

export interface IApiEditAdminRbacRoleBody extends IAdminRbacRole {
  readonly operator: string;
}

export interface IApiEditAdminRbacRoleUsersBody {
  readonly roleId: number;
  readonly userIdList: string[];
  readonly operator: string;
}

export interface IApiAddAdminRbacRoleBody {
  readonly projectId: string;
  readonly creator: string;
  readonly roleName: string;
  readonly desc: string;
  readonly type: RbacRoleType;
  readonly permissions: readonly RbacAdminPermObjectKey[];
  readonly userList: readonly string[];
}

export interface IApiDeleteAdminRbacRoleBody {
  readonly projectId: string;
  readonly roleId: number;
  readonly operator: string;
}

export interface IApiTransferOwnerRbacRoleBody {
  readonly userId: string;
  readonly fromRoleId: number;
  readonly toRoleId: number;
}

export interface ISupportUserModel {
  readonly id: number;
  readonly UserID: string;
  readonly UserName: string;
  readonly CreateTime: Date;
  readonly ModifyTime: Date;
  readonly InviterUserID?: string;
}

export interface ISupportUserModelCreate {
  readonly UserID: string;
  readonly UserName: string;
  readonly Password?: string;
}
